export default __webpack_public_path__ + "static/media/Desecrated Chestguard.fdce7c8d.jpg";